<template lang="pug">
    #crud-employee-user
        template( v-if='loading' )
            .pa-5
                v-progress-circular( color='primary' indeterminate )
        template( v-else-if='hasUsers' )
            crud-form( :fields='formDetailsFields' disabled no-buttons )
        template( v-else )
            crud-form( :fields='formGenerateFields' submit-text='crear cuenta de usuario' @reset='reset' @submitForm='submitGenerateForm' )
</template>

<script>
    //
    import { mapActions , mapState } from 'vuex'
    import { CrudForm } from '@/components/reusable_components'
    import EmployeeService from '@/services/api/employee'
    import UserService from '@/services/api/user'
    //
    import UserAccountFields from './fields/userAccount'
    import UserFields from './fields/user'
    //
    export default {
        components: {
            'crud-form': CrudForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', {
                responseConfirm: 'responseConfirm',
            }),

            /**
             * 
             */
            hasUsers () {
                return this.users.length > 0
            },
        },
        data () {
            return {
                formGenerateFields  : UserAccountFields,
                formDetailsFields   : UserFields,
                loading             : false,
                users               : [],
            }
        },
        methods: {

            /**
             * 
             */            
            ...mapActions('SnackbarModalModule', {
                initSnackbar: 'initSnackbar',
                hideSnack: 'hideSnack',
                resetSnackbarState: 'resetSnackbarState',
                setMessageConfirmSnack: 'setMessageConfirmSnack',
            }),

            /**
             * 
             */
            async fill ( data ) {
                this.verify( 
                    await UserService.fetchBy( 'rut', data.rut )
                )
            },

            /**
             * 
             */
            async reset () {
                this.fill( 
                    await EmployeeService.fetchById( this.$route.params.id ) 
                )
            },

            /**
             * 
             */
            response ( data ) {
                switch ( data.status ) {
                    case 'error':
                        this.showSnackbar( 'error', 'Error.', data.message || data.error )
                        break;                
                    case 'success':
                        this.showSnackbar( 'success', 'Éxito.', 'Cuenta de usuario generada con éxito.' )
                        this.reset()
                        break;
                }
            },

            /**
             * 
             */
            showSnackbar ( type, title, message ) {
                this.resetSnackbarState()
                this.initSnackbar( this.fillSnack( type, title, message ) )
            },

            /**
             * 
             */
            async submitGenerateForm ( data ) {
                this.response(
                    await EmployeeService.generateUserAccount( this.$route.params.id, data )
                )
            },

            /**
             * 
             */
            async verify ( data ) {
                //
                this.loading = false
                //
                const user = data.slice().shift()
                //
                this.formDetailsFields[ 0 ].value = user.auth_code
                this.formDetailsFields[ 1 ].value = user.bar_auth_code
                this.formDetailsFields[ 2 ].value = user.is_pos_workstation_user
                this.formDetailsFields[ 3 ].value = user.created_at
                //
                this.users = data
            },

            /**
             * 
             *
            async submitForm ( data ) {

                //
                const employee  = await EmployeeService.fetchById( this.$route.params.id )
                    , users     = await UserService.fetchBy( 'rut', data.rut )
                    , user      = users.slice().pop()

                if ( user ) {
                    this.response(
                        await UserService.update( user.id, { 
                            ...data,
                            'names'       : employee.names,
                            'last_name1'  : employee.last_name1,
                            'email'       : employee.email,
                        })
                    )                    
                } else {
                    this.response(
                        await UserService.create({ 
                            ...data,
                            'names'       : employee.names,
                            'last_name1'  : employee.last_name1,
                            'email'       : employee.email,
                        })
                    ) 
                }
            },*/
        },
        mounted () {
            this.reset( this.loading = true )
        },
        watch: {

            /**
             * 
             */
            $route () {
                this.reset()
            },
        },
    }
</script>

